<template>
    
    
    <div>
        <Navbar  dir="rtl" />
        <main class="main inside_main">
            <div class="container">
                <section class="messages-wrapper inside-wrapper">
                <div class="success-wrapper">
                    <h1>404</h1>
                    <h3>
                        
                         لم نتمكن من العثور على الصفحة المطلوبة
                    </h3>
                    <p>
                        يبدو أن الصفحة التي تحاول الوصول إليها غير موجودة أو تم نقلها.
                    </p>
                    <NuxtLink to="/" class="messages-btn">
                        الصفحة الرئيسية
                    </NuxtLink>
                </div>
                </section>
            </div>
            </main>

        <Footer dir="rtl"/>

        <VerifyUpdateProfileModal dir="rtl" />
            <VerifyNewMobileModal dir="rtl"  />
            <VerifyNewNameModal dir="rtl"  />
            <WarningModal dir="rtl" />
            <LoginModal dir="rtl"  />
            <GlobalAlert />
    </div>
</template>

<style scoped>
    @import '@/assets/css/success.css';
</style>

<script setup>
    import Navbar from "@/layouts/components/Navbar.vue";
    import Footer from "@/layouts/components/Footer.vue";
    import LoginModal from "@/components/LoginModal.vue";
    import VerifyUpdateProfileModal from "@/components/VerifyUpdateProfileModal.vue";
    import VerifyNewMobileModal from "@/components/VerifyNewMobileModal.vue";
    import VerifyNewNameModal from "@/components/VerifyNewNameModal.vue";
    import WarningModal from "@/components/warningModal.vue";
    import GlobalAlert from "@/components/GlobalAlert.vue";

   

</script>

